import CrossIcon from '../Icon/CrossIcon.js';
import Popper from '../../node_modules/popper.js/dist/esm/popper.js';

//
var script = {
  name: 'CustomHint',
  components: {
    CrossIcon
  },
  props: {
    targetElement: {
      type: HTMLElement,
      required: true
    },
    placement: {
      type: String,
      default: 'right-start'
    },
    offset: {
      type: String,
      default: '-2,10'
    },
    title: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      popper: undefined,
      color: '#fff'
    };
  },

  mounted() {
    if (this.hasMessage) {
      document.body.appendChild(this.$refs.message);
    }

    this.initPopper();
    if (this.$refs.next) this.$refs.next.focus();
  },

  updated() {
    if (!this.popper) {
      this.popper.destroy();
    }

    this.initPopper();
  },

  methods: {
    initPopper() {
      if (!this.$refs.message) return;
      this.popper = new Popper(this.targetElement, this.$refs.message, {
        placement: this.placement,
        modifiers: {
          offset: {
            offset: this.offset
          },
          preventOverflow: {
            boundariesElement: document.body
          }
        }
      });
    },

    onEnter() {
      this.color = '#998DD9';
    },

    onLeave() {
      this.color = '#fff';
    },

    onClose() {
      this.$emit('close');
    }

  }
};

export default script;



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/components/Spotlight/CustomHint.vue_rollup-plugin-vue=script.js